import { Component, computed, input } from '@angular/core';
import { ContactLinkPipe } from '@web/shared/pipes/contact-link.pipe';
import { isEmpty } from 'class-validator';
import { ContactCodeTagComponent } from '../../contact-code-tag.component';
import { SearchContactEntry } from '../interfaces/search-contact-entry.interface';
import { DetailItem, SearchItemBaseComponent } from './search-item-base.component';

@Component({
  selector: 'app-search-contact-item',
  imports: [ContactCodeTagComponent, ContactLinkPipe, SearchItemBaseComponent],
  template: `
    @let _item = item();

    <app-search-item-base
      icon="pi pi-address-book"
      color="text-soe-twilight-blue"
      [detailRouterLink]="_item | contactLink"
      [detailItems]="detailItems()"
    >
      <ng-template #title>
        <div [innerHTML]="_item.name"></div>
      </ng-template>

      <ng-template #codeTag>
        <app-contact-code-tag [contact]="_item" [clickable]="false" />
      </ng-template>
    </app-search-item-base>
  `,
})
export class SearchContactItemComponent {
  readonly item = input.required<SearchContactEntry>();

  readonly detailItems = computed<DetailItem[]>(() => {
    const item = this.item();

    return [
      {
        icon: 'pi pi-map-marker',
        content: item.address,
        isHtml: true,
      },
      {
        icon: 'pi pi-envelope',
        content: item.email,
        isHtml: true,
      },
      {
        icon: 'pi pi-phone',
        content: item.phoneNumber,
        isHtml: true,
      },
    ].filter((v) => !isEmpty(v.content));
  });
}
